import { Component, computed, inject, model } from '@angular/core';
import { BuildingItemDto, BuildingService, SortDto } from '@artemis-software/wr-api';
import { loader } from '@/utils/signals/loader';
import { Tracked } from '@/utils/signals/tracked';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-user-dashboard-building-overview',
  templateUrl: './user-dashboard-building-overview.component.html',
})
export class UserDashboardBuildingOverviewComponent {

  buildingService = inject(BuildingService);

  isLoading = loader();

  page = model<number>(0);
  pageSize = model<number>(10);

  results = asyncComputed(() => {
    return this.buildingService.findBuildingsByUser({
      page: this.page(),
      size: this.pageSize(),
      sort: undefined,
    });
  }, undefined, this.isLoading);

  readonly getBuildingLink = (building: BuildingItemDto) => (['building', building.id]);

  buildings = computed(() => this.results()?.items ?? []);

  count = computed(() => this.results()?.totalItems ?? 0);


}
